module.exports = __webpack_public_path__ + "img/pic_empty_curriculum@2x.b44459eb.png";